<template>
    <div class="bg p-b-60">
        <div class="w-full bg-fff n_banner_B">
            <!-- <img class="n_banner" src="../../assets//home/center_d.png" alt="" srcset=""> -->
            <img class="n_banner" :src="parkInfo.thumbnail" alt="" srcset="">
        </div>
        <div class="w-1200px m-t-347" style="position: relative;">
            <div class="w-full video_block flex h-450">
                <div class="video_b h-full" v-if="Object.keys(parkInfo).length">
                    <video-player v-if="imgVideoShow" class="video-player vjs-custom-skin my-video" style="height:450px" ref="videoPlayer"
                        :playsinline="true" :options="playerOptions">
                    </video-player>
                    <img v-else class="w-full h-full" style="object-fit:cover;" :src="parkInfo.videoUrl" alt="" srcset="">
                </div>
                <div class="left_message h-full">
                    <div class="message_padding">
                        <p class="message_title">
                            {{ parkInfo.parkName }}
                        </p>
                        <p class="message_text">
                            {{ parkInfo.detail }}
                        </p>
                        <button @click="goToParkVr(parkInfo)" class="flex bnt_fax" v-if="parkInfo.vrUrl">
                            <img src="@/assets/home/vr_icon.png" alt="" srcset=""> <span>VR</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="soluBottomRTit flex">
                <div class="soluBottomInput">
                    <!-- <div class="flex" style="align-items: center;margin-bottom: 10px;">
                        <span style="font-size: 14px;padding-left: 5px;">当前位置：</span>
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item :to="{ path: '/park' }">小镇风采</el-breadcrumb-item>
                            <el-breadcrumb-item>中心详情</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div> -->
                    <!-- <div class="soluBottomRTit2 gray soluRightBtn">
                        <p>当前位置：</p>
                        <p @click="$router.push('/')" class="solutHome">首页 /</p>
                        <p class="solutionTitle">小镇风采</p>
                    </div> -->
                </div>
            </div>
            <div class="w-full ceneter_d bg-fff">
                
                <div class="w-full center_title">
                    <span>中心详情</span>
                    <p></p>
                </div>
                <div v-html="parkInfo.description" class="center_html"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player';
import "video.js/dist/video-js.css";
import 'vue-video-player/src/custom-theme.css';
import ParkSwiper from "../parkSwiper/parkSwiper";
import {
    getParkDetail,
    getNewsItemList,
    getVrGroupList,
} from "../../utils/interface";
import { mapState } from "vuex";
export default {
    name: 'centerDetails',
    components: {
        videoPlayer
    },
    data() {
        return {
            parkId: '',
            parkInfo: {},
            imgVideoShow: true,
            setIn: null, // 定时器
            playerOptions: {
                // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    type: "video/mp4",
                    // src: require('../../assets/测试.mp4'), //你的视频地址（必填）
                    src: '', //你的视频地址（必填）
                }],
                poster: "", //你的封面地址
                width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: false,
                    durationDisplay: false,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true  //全屏按钮
                }
            },
        }
    },
    created() {
        this.parkId = this.$route.params.uuid;
        console.log(this.parkInfo, this.parkId, '初始化时的值')
        this.setIn = setInterval(() => {
            if (this.isTokenDoor === true) {
                clearInterval(this.setIn);
                this.getParkDetail();
                // this.getVrGroupList(this.parkId);
                // // 园区动态
                // this.getNewsItemList();
            }
        }, 500);

    },
    computed: {
        ...mapState({
            isTokenDoor: "isTokenDoor",
        }),
    },
    methods: {
        getParkDetail() {
            getParkDetail(this.parkId).then((res) => {
                if (res.length !== 0) {
                    this.parkInfo = res;
                    let hz = res.videoUrl.substring(res.videoUrl.lastIndexOf(".") + 1);
                    if(hz == 'mp4' || hz == 'avi' || hz == 'mov' || hz == 'wmv') {
                        this.imgVideoShow = true;
                    } else {
                        this.imgVideoShow = false;
                    }
                    this.playerOptions['sources'][0].src = res.videoUrl
                    // this.playerOptions.poster = res.thumbnail
                    // this.imageList = res.imageList;
                    // this.videoUrl = res.videoUrl;
                    // this.videoImgUrl = res.thumbnail;
                }
            });
        },
        goToParkVr(items) {
            if (items.vrUrl) {
                let routeData = this.$router.resolve({
                    name: "VeiwsUrl",
                    query: {
                        url: items.vrUrl,
                    },
                });
                window.open(routeData.href, "_blank");
            } else if (items.vrList.length > 0) {
                let routeData = this.$router.resolve({
                    name: "veiws",
                    params: { uuid: items.uuid },
                });
                window.open(routeData.href, "_blank");
            }
        },
    }
}

</script>
<style scoped lang="less">
.bg {
    background: #F2F2F2;
    position: relative;
}

.w-full {
    width: 100%;

}

.bg-fff {
    background: #fff;
}

.h-full {
    height: 100%;
}

.h-450 {
    height: 450px;
}

.m-t-347 {
    margin-top: -347px !important;
}
.m-b-60{
    margin-bottom: 60px !important;
}
.p-b-60{
    padding-bottom:60px;
    overflow: hidden;
}
.n_banner_B {
    position: relative;
    display: inline-block;
}
.n_banner_B::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);/*设置半透明黑色蒙版*/
}
.n_banner {
    width: 100%;
    object-fit: contain;
    display: block;
}
/deep/.my-video {
    .vjs-poster {
        background-size: 100% 100%;
    }
}
.soluBottomRTit {
    width: 1200px;
    margin: 0 auto;
    // padding: 30px 0 30px;
    line-height: 12px;
    padding-bottom: 20px;

    justify-content: space-between;
    align-items: center;

    .soluBottomInput {
        position: relative;

        input {
            border: none;
            background: #efefef;
            padding: 5px 13px;
            border-radius: 30px;
            height: 20px;
            width: 158px;
            font-size: 12px;
            color: #969696;
        }

        i {
            position: absolute;
            right: 5%;
            top: 50%;
            color: #969696;
            transform: translate(0, -50%);
        }
    }

    .soluBottomRFlex {
        align-items: center;
    }

    .soluBottomRTit2 {
        text-align: left;
        font-size: 28px;
        font-weight: 600;
        color: #1d1d1d;

        i {
            display: inline-block;
            background: #009999;
            width: 20px;
            height: 2px;
            position: absolute;
            bottom: 0;
            left: 0;
        }

        p {
            /*margin-bottom: 6px;*/
            line-height: 30px;
        }
    }

    .soluRightBtn {
        font-size: 14px;
        color: #6e6e6e;
        display: flex;
        align-items: center;
        font-weight: 400;
        .solutHome{
          cursor: pointer;
        }

        .solutionTitle {
            margin-left: 8px;
            color: rgba(0, 0, 0, 0.88);
        }
    }

    .newsLittleT {
        font-size: 13px;
        color: #777;
        cursor: pointer;
    }

    // .newsLittleIcon {
    //   display: inline-block;
    //   width: 2px;
    //   height: 16px;
    //   background: #efefef;
    //   margin: 0 6px;
    // }
    .newsLittleIcon2 {
        display: inline-block;
        margin: 0 6px;
        color: #777;
    }
}

/deep/.el-submenu__title {
    font-size: 16px;
    border-bottom: 1px solid #efefef;
}

.w-1200px {
    width: 1200px;
    margin: 0 auto;
}

.video_block {
    align-items: center;
    margin-bottom: 24px;

    .video_b {
        flex: 1;

        // border: 1px solid #009999;
        /deep/.video-js {
            height: 100%;
        }
    }

    .left_message {
        width: 400px;
        background: rgba(0, 153, 153, 0.75);

        .message_padding {
            padding: 60px 25px;
        }

        .message_title {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 33px;
            margin-bottom: 22px;
        }

        .message_text {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 32px;
            margin-bottom: 37px;
            max-height: 230px;
            overflow: auto;
            text-indent: 15px;
        }
        .message_text::-webkit-scrollbar { width: 0 !important }
    }
}

.ceneter_d {
    overflow: auto;
    padding: 30px 50px;
    // padding: 30px 66px;
    box-sizing: border-box;
    .center_title {
        display: flex;
        margin-bottom: 40px;
        span {
            display: inline-block;
            font-size: 22px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #1D1D1D;
            line-height: 30px;
            padding-bottom: 10px;
            border-bottom: 4px solid #009999;
        }

        p {
            flex: 1;
            border-bottom: 3px solid #E3E3E3;
        }

    }
    .center_html{
        // padding: 0 100px;
        /deep/img,
        /deep/video {
            max-width: 100% !important;
            height: auto;
        }
        /deep/table {
            border: none;
            border-collapse: collapse;
            max-width: 100% !important;
        }
        /deep/table td,
        /deep/table th {
            border: 2rpx solid #ccc;
            padding: 6rpx 10rpx;
            min-width: 100rpx;
            height: 40rpx;
        }
        /deep/table th {
            border-right: 2rpx solid #ccc;
            border-bottom: 4rpx solid #ccc;
            text-align: center;
            background-color: #f1f1f1;
        }
    }
}

.bnt_fax {
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 90px;

    img {
        width: 24px;
        height: 15px;
        margin-right: 5px;
    }
}

button {
    border: none;
    color: #009999;
    background: #fff;

    border-radius: 4px;
    // margin-top: 15px;
    font-size: 14px;
    cursor: pointer;
    margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/centerDetails/centerDetails.vue